// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

export interface PardotFormStyles {
    centeringWrapper?: InjectableCss;
    loadingSpinner?: LoadingSpinnerProps;
}

export const pardotFormStyles: PardotFormStyles = {
    centeringWrapper: {
        css: css`
            height: 300px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    loadingSpinner: {
        css: css`
            margin: auto;
        `,
    },
};
const styles = pardotFormStyles;

interface OwnProps {
    formUrl?: string;
    height?: number;
}
type Props = OwnProps;

const PardotForm: FC<Props> = ({ formUrl, height }) => {
    const [isLoading, setIsLoading] = React.useState(true);

    if (!formUrl) {
        return null;
    }

    const wrapperStyles = {
        css: css`
            iframe {
                height: calc(100vh + 145px);
            }
        `,
    };

    if (height) {
        wrapperStyles.css = css`
            iframe {
                height: ${height}px;
            }
        `;
    }

    const currentUrl = typeof window !== "undefined" ? window.location.href : "";

    return (
        <StyledWrapper {...wrapperStyles}>
            {isLoading && (
                <StyledWrapper {...styles.centeringWrapper}>
                    <LoadingSpinner {...styles.loadingSpinner}></LoadingSpinner>
                </StyledWrapper>
            )}
            <iframe
                id="pardot-iframe"
                src={`${formUrl}?RedirectUrl=${currentUrl}`}
                width="100%"
                data-type="text/html"
                allowTransparency={true}
                frameBorder="0"
                onLoad={() => setIsLoading(false)}
                sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox allow-storage-access-by-user-activation"
            ></iframe>
        </StyledWrapper>
    );
};
export default PardotForm;
